import React from 'react';

const Closure = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
      <path d="M9.849 10.83V3.004a.773.773 0 0 0-.784-.758h-1.98a.773.773 0 0 0-.783.758v7.826m6.604 10.545v-6.053A4.85 4.85 0 0 0 9.85 10.83m-3.548 0a4.85 4.85 0 0 0-3.057 4.492v6.053M6.302 8.554H9.85m7.848 3.506V4.612a.773.773 0 0 0-.784-.757h-1.98a.773.773 0 0 0-.783.757v7.448m6.604 9.315v-4.823a4.85 4.85 0 0 0-3.057-4.492" />
      <path d="M14.151 12.06a4.871 4.871 0 0 0-1.641 1.083m1.641-2.81h3.547m-3.547-1 3.547-2M14.151 7l3.547-2" />
    </g>
  </svg>
);

export default Closure;
